// Theme constants for the admin console (settings page).
// The string values are the wire contract for the persisted localStorage
// value; the UI maps each to a label via `settings:theme.<value>`.
//
// `system` follows the OS preference live (PRD-60 chunk 0). It used to be
// the silent fallback when nothing was stored, with no way back once a
// person had picked light or dark; now it is a choice with a name.

export const THEMES = ["light", "dark", "system"] as const
export type Theme = (typeof THEMES)[number]

export const THEME = {
  light: "light",
  dark: "dark",
  system: "system",
} as const

// localStorage key the theme preference is persisted under. Kept distinct
// from the i18n locale key (`platonica_admin_locale`). index.html reads the
// same key before first paint so a dark session never flashes light.
export const THEME_STORAGE_KEY = "platonica_admin_theme"

export const DEFAULT_THEME: Theme = "system"
